<template>
  <div
    class="item flex flex-column flex-middle pointer"
    @click="toDetail(data)"
  >
    <img
      v-if="data.laboratoryLogo"
      :src="data.laboratoryLogo"
      class="item-logo"
    />
    <img v-else :src="$oss('common/empty-img.png')" class="item-logo" />
    <div class="item-name ellipsis">
      {{ data.laboratoryName }}
    </div>
    <div class="item-address ellipsis">
      <label>地址：</label>
      <span>{{ data.laboratoryLocationProvince }}</span>
      <span>{{ data.laboratoryLocationCity }}</span>
      <span>{{ data.laboratoryLocationCounty }}</span>
      <span>{{ data.laboratoryAddress }}</span>
    </div>
    <div class="flex flex-row item-split">
      <div class="flex-1">
        <div class="item-num">{{ data.qualificationSum }}</div>
        <div class="item-label">资质</div>
      </div>
      <div class="flex-1">
        <div class="item-num">{{ data.waresSum }}</div>
        <div class="item-label">设备</div>
      </div>
      <div class="flex-1">
        <div class="item-num">{{ data.abilitySum }}</div>
        <div class="item-label">能力</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    toDetail({ laboratoryId }) {
      this.$jump.push({ name: "labDetail", query: { id: laboratoryId } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";

.item {
  background: white;
  padding: 15px 20px;
  border-radius: 12px;

  &-logo {
    width: 115px;
    height: 110px;
    object-fit: contain;
    background: #f9f9f9;
    margin-right: 10px;
  }

  &-name {
    padding-bottom: 10px;
    font-weight: bold;
  }

  &-address {
    color: #999999;
    font-size: 12px;
    margin-bottom: 10px;
  }

  &-split {
    > div {
      padding: 0 10px;
      text-align: center;
    }
  }

  &-num {
    color: $theme-color;
    font-size: 20px;
    margin-bottom: 4px;
  }

  &-label {
    font-size: 14px;
  }
}
</style>
